import { render } from "./BaseDialog.vue?vue&type=template&id=58f4b068&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=58f4b068&scoped=true&lang=css"

import exportComponent from "/Users/lopollo/projects/CVUE/CVUE-coaches/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f4b068"]])

export default __exports__